import { Injectable } from '@angular/core';
import { DeviceService } from '@app/core/services/device/device.service';
import { UserService } from '@app/core/services/user/user.service';
import { FieldType } from '@app/shared/constants';
import { User } from '@app/shared/models/user.interface';
import { DataSource } from '@components/data/data-table-new/datasource/datasource.component';
import { MultiselectStatus } from '@components/data/data-table-new/directives/datatable-multiselect.directive';
import { SearchFilter } from '@components/data/data-table-new/directives/datatable-search.directive';
import { DataTableState } from '@components/data/data-table-new/state/state.model';
import { Subject } from 'rxjs';

@Injectable()
export class UserSelectionWidgetTableData {
  stateId = 'userSelectionState';
  dataSource = new DataSource<User>();
  multiselectStatus: MultiselectStatus = { active: false };
  stateSubject$ = new Subject<DataTableState>();
  displayedColumns: string[] = [];
  searchFilters: SearchFilter[] = [];

  constructor(protected deviceService: DeviceService, protected userService: UserService) {
    this.displayedColumns = this.getDisplayedColumns();
    this.searchFilters = this.getSearchFilters();
  }

  protected getDisplayedColumns(): string[] {
    return ['select', 'avatar', 'name', 'surname', 'profile.name', 'userDivisions', 'phone', 'email'];
  }

  protected getSearchFilters(): SearchFilter[] {
    return [
      {
        name: 'alias',
        type: FieldType.STRING
      },
      {
        name: 'email',
        type: FieldType.STRING
      },
      {
        name: 'name',
        type: FieldType.STRING
      },
      {
        name: 'phone',
        type: FieldType.STRING
      },
      {
        name: 'surname',
        type: FieldType.STRING
      }
    ];
  }
}
